module.exports = __webpack_public_path__ + "static/media/eComicScreenPlus-01_2x.69fc60ad.png";